export default {
  choose: {
    title: '{{name}} als Inhaber entfernen',
    title_no_owner: 'Inhaber für {{restaurant}} auswählen',
    description:
      'Wählen Sie aus, wer {{name}} als Inhaber ablöst, oder lassen Sie {{restaurant}} vorerst ohne Inhaber.',
    description_no_owner: '{{restaurant}} hat keinen Inhaber. Wählen Sie jemanden aus dem Team oder eine neue Person.',
    new_owner: 'Neuer Inhaber',
    previous_owner: '{{name}} nach der Änderung',
  },
  options: {
    team: {
      title: 'Jemand aus dem Team',
      loading: 'Team wird geladen…',
      description_one: 'Ein Operator oder Mitarbeiter, {{count}} Person.',
      description_other: 'Ein Operator oder Mitarbeiter, {{count}} Personen.',
      empty: 'Es ist noch niemand anderes im Team.',
      search: 'Team nach Name oder E-Mail durchsuchen',
      no_match: 'Niemand im Team passt zu „{{query}}“.',
    },
    new: {
      title: 'Eine neue Person',
      description: 'Sie wird sofort Inhaber und erhält ihre Zugangsdaten per E-Mail.',
    },
    none: {
      title: 'Vorerst kein Inhaber',
      description: 'Wählen Sie später einen Inhaber. Bis dahin hat {{restaurant}} keinen Inhaber.',
    },
    keep: {
      title: 'Bleibt als Operator im Team',
      description: 'Behält den Zugriff auf die Restaurants, die die Person heute verwaltet.',
    },
    remove: {
      title: 'Wird aus dem Team entfernt',
      description: 'Verliert sofort den Zugriff auf das Dashboard.',
    },
  },
  roles: {
    operator: 'Operator',
    employee: 'Mitarbeiter',
  },
  fields: {
    first_name: 'Vorname',
    last_name: 'Nachname',
    email: 'E-Mail',
  },
  email_errors: {
    invalid_email: 'Geben Sie eine gültige E-Mail-Adresse ein, z. B. name@example.com.',
    email_is_owner: '{{name}} ist bereits Inhaber.',
    email_is_manager: '{{name}} ist bereits im Team.',
    email_taken:
      'Jemand außerhalb dieses Teams meldet sich bereits mit dieser E-Mail-Adresse an. Bitte verwenden Sie eine andere.',
  },
  confirm: {
    title: '{{name}} als Inhaber entfernen?',
    title_no_owner: '{{name}} zum Inhaber machen?',
    description_both: 'Beide Änderungen erfolgen gemeinsam. Schlägt eine fehl, ändert sich nichts.',
    description: 'Prüfen Sie die Änderung, bevor Sie sie bestätigen.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> hat keinen Inhaber, bis Sie einen auswählen. Alles, was den Inhaber braucht, wartet bis dahin.',
    new: '<b>{{name}}</b> wird sofort Inhaber von {{restaurant}}.',
    email:
      'Die Zugangsdaten gehen an <b>{{email}}</b>. Bitte prüfen Sie die Adresse: Wer diese E-Mail-Adresse hat, kann sich als Inhaber anmelden.',
    team: '<b>{{name}}</b> wird Inhaber von {{restaurant}}.',
    group_access:
      'Als Inhaber erhält die Person Zugriff auf alle Restaurants von {{group}}, möglicherweise mehr als heute.',
    keep: '<b>{{name}}</b> bleibt als Operator im Team.',
    remove: '<b>{{name}}</b> wird aus dem Team entfernt und kann sich nicht mehr anmelden.',
  },
  error: {
    title: 'Der Inhaber konnte nicht geändert werden.',
    description:
      'Es wurde nichts geändert. Versuchen Sie es erneut oder wenden Sie sich an den Support, wenn es weiterhin nicht klappt.',
  },
  buttons: {
    continue: 'Weiter',
    cancel: 'Abbrechen',
    back: 'Zurück',
    remove_as_owner: 'Als Inhaber entfernen',
    make_owner: 'Zum Inhaber machen',
    saving: 'Wird gespeichert…',
    try_again: 'Erneut versuchen',
    choose_instead: 'Stattdessen {{name}} auswählen',
    invite_instead: 'Stattdessen eine neue Person einladen',
  },
};
